import { sanitize } from '../utils';

const create = ({ item }) => {
    if (!item) return;
    window.dataLayer = window?.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(
        sanitize({
            event: 'view_item',
            ecommerce: {
                items: [{
                    item_name: item?.title,
                    item_id: item?.sku,
                    price: item?.price,
                    item_brand: item?.brand,
                    item_category: item?.categories?.[0],
                    item_category2: item?.categories?.[1],
                    item_category3: item?.categories?.[2],
                    item_category5: item?.isClearance,
                    item_category6: item?.isNew,
                    item_list_name: '',
                    item_list_id: '',
                    index: 1,
                    quantity: 1,
                }],
            },
        }),
    );
};

export default create;